import { render, staticRenderFns } from "./SidebarToggleableContainer.vue?vue&type=template&id=24f38b73"
import script from "./SidebarToggleableContainer.vue?vue&type=script&lang=js"
export * from "./SidebarToggleableContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports